import React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

export default createSvgIcon(React.createElement(
  'g',
  null,
  React.createElement('rect', { width: '32', height: '32', fill: 'none' }),
  React.createElement('path', { d: 'M26.23,5.78H23.94V3.15h-1.3V5.78H9.36V3.15H8.06V5.78H5.77A2.65,2.65,0,0,0,3.12,8.43V26.2a2.65,2.65,0,0,0,2.65,2.65H26.23a2.65,2.65,0,0,0,2.65-2.65V8.43a2.65,2.65,0,0,0-2.65-2.65Zm-15.34,19H7.54v-1.3h3.35Zm0-4H7.54v-1.3h3.35Zm6.79,4H14.32v-1.3h3.36Zm0-4H14.32v-1.3h3.36Zm0-4H14.32v-1.3h3.36Zm6.78,8H21.11v-1.3h3.35Zm0-4H21.11v-1.3h3.35Zm0-4H21.11v-1.3h3.35Zm3.12-5.39H4.42V8.43A1.35,1.35,0,0,1,5.77,7.08H26.23a1.35,1.35,0,0,1,1.35,1.35Z' })
));